module.exports = __webpack_public_path__ + "static/climatisation4-cf040743802d2278b2a5278f301fa0d7.jpg";